<template>
    <div>
    <span
        v-on:click="showModal"
        :class="[btnInverted ? btnThemeInverted : btnTheme ]"
    >
            {{  btnName }}
    </span>
        <div v-if="showConfirm" class="modal-mask" @click="closeModal">
            <div class="modal-wrapper" @click.stop>
                <div class="modal-container">
                    <div class="modal-header">
                        <slot name="header">
                            {{ header }}
                        </slot>
                    </div>
                    <div class="modal-body">
                        <slot name="body">
                            <div v-html="jurisdictions"></div>
                        </slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <a
                                :href="link"
                                class="modal-default-button btn btn-primary"
                            >
                                OK
                            </a>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

  export default {

    props: {
      header: {
        required: true
      },
      userDetails: {
        type: Object
      },
      jurisdictions: String,
      link: String,
      btnName: String,
      btnInverted: Boolean,
    },
    data() {
      return {
        showConfirm: false,
        btnTheme: 'btn btn-blue btn-lauren margin-top-15 width-340 padding-left-20 padding-right-20',
        btnThemeInverted: 'btn btn-lauren btn-blue btn-inverted width-340'
      }
    },
    methods: {
      showModal() {
        this.showConfirm = true
      },
      closeModal() {
        this.showConfirm = false
      },
    }

  }
</script>
